/* istanbul ignore file */
import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import SingleProjectBreadcrumbs from 'domain/projects/project/shared/SingleProjectBreadcrumbs';
import { useProjectWeeklyReportsUrl } from 'domain/shared/project';

const ProjectWeeklyReportsBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useProjectWeeklyReportsUrl();
  const projectWeeklyReportsListLink = getListUrl();

  return (
    <SingleProjectBreadcrumbs>
      <ListBreadcrumbItem entity="Weekly Report" link={projectWeeklyReportsListLink} />
      {children}
    </SingleProjectBreadcrumbs>
  );
};

export default ProjectWeeklyReportsBreadcrumbs;
